import { useSuspenseDynamicConfig } from 'FrontRoyalStatsig';
import { camelize } from 'String';
import { type AudioUiContext } from '../TutorBotConversation.types';

type CompleteEntry = {
    sessionTimeLimitSeconds: number;
    sessionEndWarningSeconds: number;
    weeklyTimeLimitSeconds: number;
};
type OverrideEntry = {
    sessionTimeLimitSeconds?: number;
    sessionEndWarningSeconds?: number;
    // cannot override weeklyTimeLimitSeconds. That is not specific to a
    // particular ui context
};

type EntriesByUiContext = Record<string, OverrideEntry>;

type Config = CompleteEntry & EntriesByUiContext;

export function useVoiceAgentStatsigConfig(uiContext: AudioUiContext): CompleteEntry {
    const config = useSuspenseDynamicConfig<Config>('tutor_bot_voice_agent');
    const baseEntry = {
        sessionTimeLimitSeconds: config.sessionTimeLimitSeconds,
        sessionEndWarningSeconds: config.sessionEndWarningSeconds,
        weeklyTimeLimitSeconds: config.weeklyTimeLimitSeconds,
    };
    const uiContextOverrides = config[camelize(uiContext, false)] || {};

    const mergedEntry: CompleteEntry = {
        ...baseEntry,
        ...uiContextOverrides,
    };
    return mergedEntry;
}

export function useWeeklyTimeLimitSeconds(): number {
    const config = useSuspenseDynamicConfig<Config>('tutor_bot_voice_agent');
    return config.weeklyTimeLimitSeconds;
}
